import { Helpers } from '../../helpers';
import { ITeamDevelopmentArea } from '../../interfaces/iteam-development-area';
import { AssetTeam } from '../asset-team';
import { Division } from '../division';
import { ProjectPondParameter } from '../project-pond-parameter';

export class TeamDevelopmentAreaBase {
  TeamDevelopmentAreaId: number;
  Description: string;
  Alias: string | null;
  SortOrder: number | null;
  AssetTeamId: number | null;
  DivisionId: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ProjectPondParameters_TeamDevelopmentArea?: Array<ProjectPondParameter> | null;
  AssetTeam?: AssetTeam;
  Division?: Division;

  constructor(item?: ITeamDevelopmentArea) {
    if (item) {

      this.TeamDevelopmentAreaId = item.TeamDevelopmentAreaId;
      this.Description = item.Description;
      this.Alias = item.Alias;
      this.SortOrder = item.SortOrder;
      this.AssetTeamId = item.AssetTeamId;
      this.DivisionId = item.DivisionId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ProjectPondParameters_TeamDevelopmentArea = Helpers.createClassArray(ProjectPondParameter, item.ProjectPondParameters_TeamDevelopmentArea);
      this.AssetTeam = new AssetTeam(item.AssetTeam);
      this.Division = new Division(item.Division);
    }
  }
}